import { useEffect } from 'react'

import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'

type Params = CustomFormViewerQuestionProps

type Return = { defaultValue: string[] }

export default function useCustomFormGetDefaultValueAsArray({ question, questionKey, formMethods }: Params): Return {
  const defaultValue = question?.default_value || []

  useEffect(() => {
    if (formMethods?.setValue && defaultValue) {
      formMethods?.setValue(questionKey, defaultValue)
    }
  }, [])

  return { defaultValue }
}
